import React, { useState, useEffect } from "react";
import { Table, Pagination, Container, Card } from "react-bootstrap";
import "../../subscription.css";
import { useSelector, useDispatch } from "react-redux";
import { getSubscription } from "../../store/slices/user";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function SubscriptionMembers() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { subscriptionList, loading } = useSelector((state) => state.user);

  const perPage = 10;
  const [meta, setMeta] = useState({
    total: 0,
    page: 1,
    limit: perPage,
  });

  useEffect(() => {
    dispatch(
      getSubscription({
        page: currentPage,
        limit: perPage,
      }),
    ).then((res) => {
      const payload = res.payload || {};

      setMeta({
        total: payload.total || 0,
        page: payload.page || currentPage,
        limit: payload.limit || perPage,
      });
    });
  }, [dispatch, currentPage]);

  const total = meta.total;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const startIndex = (currentPage - 1) * perPage;
  const currentData = subscriptionList || [];
  const handleExport = () => {
    const exportData = subscriptionList.map((item, index) => ({
      "Sl No": index + 1,
      "Member Name": item.user?.name || "-",
      "Plan": item.plan?.name || item.planSnapshot?.name || "-",
      "Start Date": item.planStartsAt
        ? new Date(item.planStartsAt).toLocaleDateString("en-IN")
        : "-",
      "Expiry Date": item.planExpiresAt
        ? new Date(item.planExpiresAt).toLocaleDateString("en-IN")
        : "-",
      "Validity":
        item.planExpiresAt
          ? `${Math.max(
            Math.ceil(
              (new Date(item.planExpiresAt) - new Date()) /
              (1000 * 60 * 60 * 24)
            ),
            0
          )} days`
          : "-",
      "Status": item.status || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscriptions");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(
      file,
      `Subscriptions_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  return (
    <>
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">
            <IoIosArrowForward size={15} />{" "}
          </span>

          <span className="breadcrumb-link inactive">Subscription</span>
        </div>
      </div>

      <Container className="wrap ">
        <Card className="customtable-card">
          <Card.Body className="d-flex justify-content-end">
            <Button variant="success" onClick={handleExport}>
              Export Excel
            </Button>
          </Card.Body>
          <div className="table-responsive">
            <Table className="custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Member</th>

                  <th>Plan</th>
                  <th>Start</th>
                  <th>Expiry</th>
                  {/* <th>Validity</th> */}
                  <th>Status</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>

              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    <td className="index">{index + 1}</td>

                    <td>
                      <div>
                        <div>{item.user?.name}</div>
                      </div>
                    </td>

                    <td>
                      <span className="dur-badge">
                        {item?.plan?.name || item?.planSnapshot?.name || "-"}
                      </span>
                    </td>

                    <td>
                      {item?.planStartsAt
                        ? new Date(item.planStartsAt).toLocaleDateString()
                        : "-"}
                    </td>

                    <td>
                      {item?.planExpiresAt
                        ? new Date(item.planExpiresAt).toLocaleDateString()
                        : "-"}
                    </td>


                    <td>
                      <span
                        className={`badge ${item?.status === "Active"
                          ? "active"
                          : item.status === "Trial"
                            ? "trial"
                            : "inactive"
                          }`}
                      >
                        {item?.status}
                      </span>
                    </td>
                    {/* ACTIONS */}
                    {/* <td>
                      <div className="actions">
                        <button className="act-btn edit">
                          <IoMdEye />
                        </button>
                        <button className="act-btn tog">🔄</button>
                        <button className="act-btn del">
                          <IoMdTrash />
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="pagination-wrap mx-3">
            <div>
              Showing {total === 0 ? 0 : startIndex + 1} –{" "}
              {Math.min(startIndex + perPage, total)} of {total}
            </div>

            <Pagination className="custom-pagination">
              <Pagination.Prev
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
              />

              {[...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              ))}

              <Pagination.Next
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </Card>
      </Container>
    </>
  );
}
